import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip } from '@vectord/components';

import { setSbatGroupLocked } from 'features/classCreation';

function RescheduleSbatGroupLock({ sbatGroup, disabled }) {
  const dispatch = useDispatch();

  const handleToggle = useCallback(
    (event) => {
      if (disabled) return;

      dispatch(
        setSbatGroupLocked({
          sbatGroupId: sbatGroup.id,
          locked: event.target.checked,
        })
      );
    },
    [disabled, dispatch, sbatGroup.id]
  );

  return (
    <Tooltip
      className="p-xxs"
      component="div"
      title="Go back to previous step if you need to lock/unlock lectures"
      isDisabled={!disabled}
    >
      <input
        checked={sbatGroup.locked}
        className="cursor"
        disabled={disabled}
        onChange={handleToggle}
        type="checkbox"
      />
    </Tooltip>
  );
}

export default RescheduleSbatGroupLock;
